/**
 * ConfidenceDot Component
 * 
 * Displays a small colored dot indicating match confidence level
 * Used in property listings to show Land Registry match quality
 */

import React from "react";
import PropTypes from "prop-types";

export const ConfidenceDot = ({ confidence }) => {
  const getColor = () => {
    switch (confidence) {
      case "high":
        return "#10b981"; // Green
      case "medium":
        return "#f59e0b"; // Amber/Orange
      default:
        return "#d1d5db"; // Grey (no data)
}
  };

  const getTitle = () => {
    switch (confidence) {
      case "high":
        return "High confidence Land Registry match";
      case "medium":
        return "Medium confidence Land Registry match";
      default:
        return "No Land Registry match data";
    }
  };

  return (
    <div
      style={{
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: getColor(),
        flexShrink: 0,
      }}
      title={getTitle()}
    />
  );
};

ConfidenceDot.propTypes = {
  confidence: PropTypes.oneOf(["high", "medium", null, undefined]),
};

export default ConfidenceDot;
